import { StatementStatus } from 'app/dataTypes/cafeteria/compensation/statements'


export const getStatusColor = (status: StatementStatus) => {
  if (status === StatementStatus.Draft) return 'dodgerblue'
  if (status === StatementStatus.Consideration) return 'orange'
  if (status === StatementStatus.Processing) return 'magenta'
  if (status === StatementStatus.Approved) return 'limegreen'
  if (status === StatementStatus.Denied) return 'orangered'
  if (status === StatementStatus.Deleted) return 'slategray'

  return 'gainsboro'
}
